import UserAvatar from "assets/images/v2/user-avatar.svg";
import "./ProfileMenu.scss";

interface ProfileMenuProps {
  readonly onClick?: () => void;
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({ onClick }) => {
  return (
    <div className="profile-menu" onClick={onClick} style={{ cursor: "pointer" }}>
      <img src={UserAvatar} alt="User icon" />
    </div>
  );
};

export default ProfileMenu;
